import { render } from "./StampantiTable.vue?vue&type=template&id=09ed858d&scoped=true"
import script from "./StampantiTable.vue?vue&type=script&lang=js"
export * from "./StampantiTable.vue?vue&type=script&lang=js"

import "./StampantiTable.vue?vue&type=style&index=0&id=09ed858d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ed858d"]])

export default __exports__